function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import debounce from 'lodash/debounce';
import axios from 'axios';
import { Combobox, FormField, Label, VisuallyHidden } from '@zillow/constellation';
import ErrorMessage from './components/ErrorMessage';
import SearchInput from './components/SearchInput';
var StyledForm = styled.form.withConfig({
  displayName: "PropertySearch__StyledForm",
  componentId: "sc-1op3qtn-0"
})(["width:100%;position:relative;"]);
var ADDRESS_SEARCH_ID = 'address-search';
var DEFAULT_COMBOBOX_PROPS = {
  options: [],
  // We need to prevent the Combobox from showing the empty state when we have no results
  // because we just haven't searched yet. Otherwise, the user focuses the Combobox and
  // we immediately tell them that there are no results.
  renderEmptyState: null
};
var NO_ADDRESS_FOUND_ERROR_MESSAGE = "Sorry, we couldn't find that address.";
var AUTOCOMPLETE_UNREACHABLE_ERROR_MESSAGE = 'Something went wrong, try again later.';

var PropertySearch = function PropertySearch(_ref) {
  var _ref$renderInput = _ref.renderInput,
      _renderInput = _ref$renderInput === void 0 ? SearchInput : _ref$renderInput,
      _ref$renderError = _ref.renderError,
      renderError = _ref$renderError === void 0 ? ErrorMessage : _ref$renderError,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? function () {} : _ref$onError,
      addressAutocompleteUrl = _ref.addressAutocompleteUrl,
      _ref$maxSuggestions = _ref.maxSuggestions,
      maxSuggestions = _ref$maxSuggestions === void 0 ? 5 : _ref$maxSuggestions,
      _ref$renderEmptyState = _ref.renderEmptyState,
      renderEmptyState = _ref$renderEmptyState === void 0 ? undefined : _ref$renderEmptyState,
      defaultAddressValue = _ref.defaultAddressValue;

  var _useState = useState(defaultAddressValue !== null && defaultAddressValue !== void 0 ? defaultAddressValue : ''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(DEFAULT_COMBOBOX_PROPS),
      _useState4 = _slicedToArray(_useState3, 2),
      comboboxProps = _useState4[0],
      setComboboxProps = _useState4[1];

  var queryRef = useRef();

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var queryAutocomplete = useCallback(function (query) {
    axios.get(addressAutocompleteUrl, {
      params: {
        q: query,
        resultTypes: 'allAddress',
        resultCount: maxSuggestions
      }
    }).then(function (response) {
      var _response$data;

      /*
      Make sure the query still exists for this request.
      Since it takes a moment to receive a response from the autocomplete
      service, it's  possible the user has typed more and kicked off a
      new request to the autocomplete service, and we should just wait
      and handle that response instead. Otherwise we can have old
      request responses overwrite newer requests
       */
      if (queryRef.current !== query) {
        return;
      }

      var options = [];
      var results = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.results;

      if (results !== null && results !== void 0 && results.length) {
        options = results // Only show responses with zpids, because we can't do anything
        // without a zpid
        .filter(function (result) {
          var _result$metaData;

          return (_result$metaData = result.metaData) === null || _result$metaData === void 0 ? void 0 : _result$metaData.zpid;
        }).map(function (result) {
          var _result$metaData2, _result$metaData3, _result$metaData4;

          return {
            id: (_result$metaData2 = result.metaData) === null || _result$metaData2 === void 0 ? void 0 : _result$metaData2.zpid,
            lat: (_result$metaData3 = result.metaData) === null || _result$metaData3 === void 0 ? void 0 : _result$metaData3.lat,
            lng: (_result$metaData4 = result.metaData) === null || _result$metaData4 === void 0 ? void 0 : _result$metaData4.lng,
            value: result.display,
            label: result.display
          };
        });
      } // Only display the address suggestion list if there are 1 or more
      // suggestions in the options array and the user changed the input


      setComboboxProps({
        options: options,
        renderEmptyState: renderEmptyState
      });
    }).catch(function (err) {
      setError(AUTOCOMPLETE_UNREACHABLE_ERROR_MESSAGE);
      onError(err);
      setComboboxProps(DEFAULT_COMBOBOX_PROPS);
    });
  }, [addressAutocompleteUrl, maxSuggestions, onError, renderEmptyState]); // Memoize the handler and only call debounce during initial rendering:

  var debouncedHandleChange = useMemo(function () {
    return debounce(function (nextValue) {
      setError('');
      setValue(nextValue);
      onChange(nextValue);
      var query = nextValue.trim();
      queryRef.current = query;

      if (query) {
        queryAutocomplete(query);
      } else {
        // If there's no query, we don't need to search, we should
        // just return to the default props
        setComboboxProps(DEFAULT_COMBOBOX_PROPS);
      }
    }, 500);
  }, [queryAutocomplete, setValue, onChange]);
  useEffect(function () {
    debouncedHandleChange.cancel();
  }, [debouncedHandleChange]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledForm, {
    onSubmit: function onSubmit(e) {
      e.preventDefault(); // If the user hits enter while there are matching addresses,
      // the top address will be submitted via the Combobox onOptionSelect
      // calling onSubmit.
      // If the user hits enter while there are no addresses, the
      // Combobox dropdown will close.
      // If they hit enter one more time, we should show them an error
      // message.

      setError(NO_ADDRESS_FOUND_ERROR_MESSAGE);
      onError(NO_ADDRESS_FOUND_ERROR_MESSAGE);
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    controlId: ADDRESS_SEARCH_ID
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, /*#__PURE__*/React.createElement(Label, null, "Enter your address, press enter to submit")), /*#__PURE__*/React.createElement(Combobox, _extends({
    freeForm: true,
    renderInput: function renderInput(props) {
      return _renderInput(Object.assign({}, props, comboboxProps));
    },
    value: value,
    optionFilter: null,
    focusFirstOption: true,
    onChange: debouncedHandleChange,
    onOptionSelect: function onOptionSelect(option) {
      return onSubmit({
        zpid: Number(option.id),
        address: option.value,
        lat: option.lat,
        lng: option.lng
      });
    },
    autoCompleteBehavior: "automatic"
  }, comboboxProps)))), error && renderError({
    errorMessage: error
  }));
};

export default PropertySearch;
//# sourceMappingURL=PropertySearch.js.map